a.fp-link(@click='logout' data-test='logout.link') {{ t('logout') }}
